// src/components/global-ui/GlobalDrawers.tsx
import useUiStore from "../../store/useUiStore.ts";

const GlobalDrawer = () => {
  const {drawer} = useUiStore();

  if (!drawer.isVisible) {
    return null;
  }
  if (drawer.isVisible) {
    return drawer.content;
  }
};

export default GlobalDrawer;